import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { compare } from '../../utils/categories';
//
// Компонент отображающий основные категории
// Их надо растащить по папкам
//
const ExhibitorViewMainCategories = ({ categoriesAll, categoriesChosen }) => {
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [ folders, setFolders ] = useState([]);
    const [ orphans, setOrphans ] = useState([]);

    useEffect(() => {
        const folders = [];
        const orphans = [];

        categoriesAll.forEach(cat => {
            if(cat.is_folder && cat.type === 'main') {
                const folder = { ...cat, categories: [] };

                categoriesChosen.forEach(cat => {
                    if(cat.folder === folder._id) folder.categories.push(cat);
                });

                if(folder.categories.length > 0) {
                    folders.push(folder);
                }
            }
        });

        categoriesChosen.forEach(cat => {
            if(!cat.folder) orphans.push(cat);
        });

        folders.sort((a, b) => compare(a, b, lang));
        orphans.sort((a, b) => compare(a, b, lang));

        setFolders(folders);
        setOrphans(orphans);
    }, [ categoriesAll, categoriesChosen, lang ]);

    if(categoriesChosen.length < 1) return (<>
        <h3>{t('eventview.catmain')}</h3>
        <div>{t('exhibitorview.nocategories')}</div>
    </>);

    return (<>
        <h3>{t('eventview.catmain')}</h3>

        <ul>
            {folders.map(folder => (
                <li key={folder._id}>
                    {folder.name[lang]}
                    <ul>
                        {folder.categories.sort((a, b)=>compare(a, b, lang)).map(cat => (
                            <li key={cat._id}>
                                {cat.name[lang]}
                            </li>
                        ))}
                    </ul>
                </li>
            ))}

            {orphans.length > 0 && <li>
                {t('eventview.nofolder')}
                <ul>
                    {orphans.map(cat => (
                        <li key={cat._id}>
                            {cat.name[lang]}
                        </li>
                    ))}
                </ul>                
            </li>}
        </ul>
    </>);
};

ExhibitorViewMainCategories.propTypes = {
    categoriesAll: PropTypes.array.isRequired,
    categoriesChosen: PropTypes.array.isRequired,
};

export default ExhibitorViewMainCategories;
